import { render } from "./EligibilityPayers.vue?vue&type=template&id=6ae2d004&ts=true"
import script from "./EligibilityPayers.vue?vue&type=script&lang=ts"
export * from "./EligibilityPayers.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__